function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

export { getNodeName as default };
